class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.addSuggestionDrawerOpen();
    this.setSuggestionSlider();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  addSuggestionDrawerOpen() {
    const suggestionCloseButton = document.querySelector(
      ".suggestion-drawer-close"
    );
    const suggestionDrawer = document.querySelector(
      ".drawer__inner__with__suggestion"
    );
    const noSuggestionDrawer = document.querySelector(
      ".drawer__without__suggestion"
    );
    const mainDrawer = document.querySelector(".drawer__inner");

    let isOpen = true;

    suggestionCloseButton.addEventListener("click", function () {
      if (isOpen) {
        suggestionDrawer.classList.add("closing");
        noSuggestionDrawer.classList.remove("suggestion-shadow");
        setTimeout(() => {
          mainDrawer.classList.add("drawer__inner__small__width");
        }, 300);
        isOpen = false;
      } else {
        suggestionDrawer.classList.remove("closing");
        mainDrawer.classList.remove("drawer__inner__small__width");
        suggestionDrawer.classList.add("opening");
        noSuggestionDrawer.classList.add("suggestion-shadow");

        setTimeout(() => {
          suggestionDrawer.classList.remove("opening");
        }, 300);
        isOpen = true;
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();

      this.afterRender();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  setSuggestionSlider() {
    const images = document.querySelectorAll(
      ".mobile__suggestion__container .suggestion-container-mobile"
    );
    const mobileSuggestionContainer =
      document.getElementById("mobile-suggestions");

    let currentIndex = 0;
    let isDragging = false;
    let translate = 0;
    let startX = 0;

    mobileSuggestionContainer.addEventListener("touchstart", touchStart);
    mobileSuggestionContainer.addEventListener("touchmove", touchMove);
    mobileSuggestionContainer.addEventListener("touchend", touchEnd);

    function getPositionX(e) {
      return e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
    }

    function touchStart(e) {
      startX = getPositionX(e);
      isDragging = true;
    }

    function touchMove(e) {
      if (!isDragging) return;

      const currentX = getPositionX(e);
      translate = currentX - startX;
    }

    function touchEnd() {
      if (!isDragging) return;
      isDragging = false;

      if (translate < -60) {
        showPrevImage();
      } else if (translate > 60) {
        showNextImage();
      }
    }

    images[currentIndex].classList.add("suggestion-active-from-right");

    function showNextImage() {
      // Cache l'image actuelle
      images[currentIndex].classList.remove("suggestion-active-from-right");
      images[currentIndex].classList.remove("suggestion-active-from-left");
      images[currentIndex].classList.add("suggestion-inactive");

      // Passe à l'image suivante
      currentIndex = (currentIndex + 1) % images.length;

      // Affiche la nouvelle image
      images[currentIndex].classList.remove("suggestion-inactive");
      images[currentIndex].classList.add("suggestion-active-from-left");
    }

    function showPrevImage() {
      // Cache l'image actuelle
      images[currentIndex].classList.remove("suggestion-active-from-right");
      images[currentIndex].classList.remove("suggestion-active-from-left");
      images[currentIndex].classList.add("suggestion-inactive");

      // Passe à l'image suivante
      currentIndex = (currentIndex + 1) % images.length;

      // Affiche la nouvelle image
      images[currentIndex].classList.remove("suggestion-inactive");
      images[currentIndex].classList.add("suggestion-active-from-right");
    }
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  afterRender() {
    this.setSuggestionSlider();
    this.addSuggestionDrawerOpen();
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
